<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      坪山站<br>
站点介绍<br>
坪山站是16号线一期的第14个车站（16号线一期开通24个车站），坪山站车站编号为1622，为集中站，隶属坪山站集中区。坪山站为地下三层站，其中，地下一层为交通层，地下二层为站厅层，地下三层为站台层。站台为岛式站台。 坪山站位于高铁坪山站南侧站前路下，呈东西向布置。坪山站位于高铁坪山站南侧站前路下，沿站前路呈东西向布置。车站北侧为坪山高铁站，南侧为同心水泥制品厂。车站设置有4个出入口，其中A口为主要紧急出入口,B口为备用紧急出入口。田心方向公交接驳口在B口、大运方向公交接驳口在C口，B出入口通道处设置公共卫生间（含第三卫生间）。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:19	23:28	16号线	5分32秒	6分45秒<br>
田心	06:04	23:20	16号线	5分32秒	6分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:29	23:28	16号线	5分50秒	6分钟-9分钟<br>
田心	06:10	23:20	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:29	00:28	16号线	5分50秒	6分钟-9分钟<br>
田心	06:10	00:20	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
站前路南侧（西）、东部城轨、栩康二手交易中心、奋斗广场<br><br>
B出入口:<br>
站前路南侧（东）、麗枫酒店<br><br>
C出入口:<br>
站前路北侧（东）、同心水泥制品厂<br><br>
D出入口:<br>
站前路北侧（西）、深圳坪山站<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 坪山火车站南广场<br>
802、M546、939B、963、M165、M325、M422、M426、M427、M440、M478、M479、M497<br><br>
D出入口:<br>
公交站名： 坪山火车站南广场<br>
802、M546、939B、963、M165、M325、M422、M426、M427、M440、M478、M479、M497<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>